// extracted by mini-css-extract-plugin
export default {"custTabs":"tabs_custTabs__vL6DN","custTabContent":"tabs_custTabContent__Bb08c"};